import type { ObjectType } from "models-webgl2";
import { isFunction } from "./is-function";

export const makeAutoBindFunctions = <T extends ObjectType>(instance: T): T => {
  const prototype = Object.getPrototypeOf(instance);
  const properties = Object.getOwnPropertyNames(prototype);

  for (const property of properties) {
    const value = instance[property];
    if (property !== "constructor" && isFunction(value)) {
      (instance as any)[property] = value.bind(instance);
    }
  }

  return instance;
};
